import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import type { ModalOptions } from '@ionic/core/components';

@Injectable({ providedIn: 'root' })
export class ModalService {
  constructor(private modalController: ModalController) {}

  async getTop(): Promise<HTMLIonModalElement | undefined> {
    return this.modalController.getTop();
  }

  async dismiss<T>(data?: T, role?: string): Promise<boolean> {
    return (await this.modalController.getTop()) ? await this.modalController.dismiss(data, role) : true;
  }

  async create(opts: ModalOptions): Promise<HTMLIonModalElement> {
    return this.modalController.create(opts);
  }
}
